import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { AssetIcon } from '../../../shared/assets';
import { DataTable, StatusPill, IconActionButton } from '../../../shared/components/patterns';
import { useLinkedEntityCards } from '../../../shared/components/linked-entities/LinkedEntityCardHost';
import { formatCurrency, toLocalDateKey } from '../utils/dashboard.helpers';

export const OVERDUE_MODULES = [
  { id: 'all', label: 'Tutti i moduli', icon: 'status.warning' },
  { id: 'task', label: 'Task', icon: 'nav.tasks' },
  { id: 'proposals', label: 'Proposte affari', icon: 'nav.dealsProposals' },
  { id: 'inProgress', label: 'Affari in corso', icon: 'nav.dealsActive' },
  { id: 'completedDeals', label: 'Affari completati', icon: 'nav.dealsCompleted' },
  { id: 'payments', label: 'Incassi e fatture', icon: 'nav.accounting' },
  { id: 'expenses', label: 'Uscite', icon: 'nav.expenses' },
  { id: 'calendar', label: 'Calendario', icon: 'nav.calendar' },
];
const lateDays = (date) => Math.max(0, Math.round((Date.parse(toLocalDateKey(new Date())) - Date.parse(String(date).slice(0, 10))) / 86400000));
const formattedDate = (date) => new Date(`${String(date).slice(0, 10)}T00:00:00`).toLocaleDateString('it-IT');

export default function OverdueDashboardView({ items = [], unavailableModules = [] }) {
  const [activeModule, setActiveModule] = useState('all');
  const { openEntityCard } = useLinkedEntityCards();
  const navigate = useNavigate();
  const modules = OVERDUE_MODULES.map((module) => ({ ...module, count: module.id === 'all' ? items.length : items.filter((item) => item.type === module.id).length }));
  const visible = activeModule === 'all' ? items : items.filter((item) => item.type === activeModule);
  const open = (item) => { if (!openEntityCard({ entityType: item.entityType, entityId: item.entityId })) navigate(item.route); };
  return <section className="dashboard-overdue" aria-labelledby="dashboard-overdue-title">
    <header className="dashboard-overdue__header">
      <div>
        <h2 id="dashboard-overdue-title"><AssetIcon name="status.warning" size={32} className="wt-tone wt-tone--warning wt-tone--icon" />In ritardo</h2>
        <p>Scadenze superate ancora aperte, suddivise per modulo.</p>
      </div>
      <Link to="/" className="dashboard-overdue__back"><AssetIcon name="nav.dashboard" size={16} />Torna alla dashboard</Link>
    </header>
    {unavailableModules.length ? <p role="alert" className="wt-inline-error">Dati non disponibili per {unavailableModules.join(', ')}. Il riepilogo include i moduli caricati.</p> : null}
    <div className="dashboard-overdue__modules" role="group" aria-label="Moduli con scadenze in ritardo">
      {modules.filter((module) => module.id === 'all' || module.count > 0).map((module) => <button key={module.id} type="button"
        className={`dashboard-overdue__module${activeModule === module.id ? ' is-active' : ''}`} aria-pressed={activeModule === module.id} onClick={() => setActiveModule(module.id)}>
        <span><AssetIcon name={module.icon} size={32} />{module.label}</span><strong>{module.count}</strong>
      </button>)}
    </div>
    <DataTable ariaLabel="Scadenze in ritardo per modulo" rows={visible} onRowClick={open}
      emptyState="Nessuna scadenza aperta in ritardo per questo modulo."
      columns={[
        { id: 'type', header: 'Modulo', render: (item) => item.typeLabel },
        { id: 'title', header: 'Descrizione', render: (item) => <><strong className="dashboard-overdue__title">{item.title}</strong><span className="dashboard-overdue__counterparty">{[item.counterparty, item.installment ? `Rata ${item.installment}` : ''].filter(Boolean).join(' · ')}</span></> },
        { id: 'dueDate', header: 'Scadenza', render: (item) => formattedDate(item.dueDate) },
        { id: 'delay', header: 'Ritardo', render: (item) => <StatusPill label={`${lateDays(item.dueDate)} ${lateDays(item.dueDate) === 1 ? 'giorno' : 'giorni'}`} tone="review" /> },
        { id: 'amount', header: 'Importo', render: (item) => item.amount != null ? formatCurrency(item.amount) : '—' },
        { id: 'actions', header: '', render: (item) => <IconActionButton iconKey="actions.preview" label={`Apri ${item.title}`} onClick={() => open(item)} /> },
      ]} />
  </section>;
}
